module.exports = __webpack_public_path__ + "static/media/livingroom.8cc3e8b1.png";